<template>
  <div id="app">
    <TmHeader :open="header.open" @toggle="header.open = !header.open">
      <TmLogo slot="logo" title="Môj Telekom" />
      <template slot="links">
        <TmLink icon="home-small">
          <a href="/">Telekom Web</a>
        </TmLink>
      </template>
    </TmHeader>
    <router-view />
  </div>
</template>
<script>
import { TmHeader, TmLogo, TmLink } from "@tmcz/tmcz-vue-ui"

export default {
  data() {
    return {
      header: {
        open: false
      }
    }
  },
  components: {
    TmHeader,
    TmLogo,
    TmLink
  }
}
</script>
<style>
@import './assets/css/main.css';

#app {
  font-family: TeleGrotesk, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
